import { isProCodeComponentType } from './isProCodeComponentType';
/**
 * @deprecated use same function from '@rchh/lowcode-utils' instead
 */
export function isLowCodeComponentType(desc) {
  return !isProCodeComponentType(desc);
}